import Vue from 'vue'
import EventBus from '@/helpers/event-bus'

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_FAILED = 'LOGIN_FAILED'
const LOGOUT = 'LOGOUT'
const USER = 'UPDATE_USER'
const BIRTHDATE = 'UPDATE_BIRTHDATE'
const FIRSTNAME = 'UPDATE_FIRSTNAME'
const LASTNAME = 'UPDATE_LASTNAME'
const GENRE = 'UPDATE_GENRE'
const PHONE = 'UPDATE_PHONE'
const COUNTRY = 'UPDATE_COUNTRY'
const AVATAR = 'UPDATE_AVATAR'

const state = {
  isLoggedIn: !!localStorage.getItem('token'),
  user: JSON.parse(localStorage.getItem('user', '')),
  pending: null
}

const mutations = {
  [LOGIN] (state) {
    state.pending = true
  },
  [LOGIN_SUCCESS] (state) {
    state.isLoggedIn = true
    state.pending = false
  },
  [LOGIN_FAILED] (state) {
    state.isLoggedIn = false
    state.pending = false
  },
  [LOGOUT] (state) {
    state.isLoggedIn = false
  },
  [USER] (state, user) {
    state.user = user
  },
  [BIRTHDATE] (state, date) {
    state.user.birthdate = date
  },
  [FIRSTNAME] (state, firstName) {
    state.user.first_name = firstName
    state.user.name = firstName + ' ' + state.user.last_name
  },
  [LASTNAME] (state, lastName) {
    state.user.last_name = lastName
    state.user.name = state.user.first_name + ' ' + lastName
  },
  [GENRE] (state, genre) {
    state.user.genre = genre
  },
  [PHONE] (state, phone) {
    state.user.phone = phone
  },
  [COUNTRY] (state, country) {
    state.user.country = country
  },
  [AVATAR] (state, url) {
    state.user.avatar = url
  }
}

const actions = {
  login ({commit}, creds) {
    commit(LOGIN)
    EventBus.$emit('waitMessage')
    return Vue.http.post('users/auth/', creds)
    .then(response => {
      var data = response.body
      if (data.status === 'ok') {
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data.user))
        commit(USER, data.user)
        commit(LOGIN_SUCCESS)
      } else {
        commit(LOGIN_FAILED)
        EventBus.$emit('errorMessage', response.body.message)
      }
    }, response => {
      commit(LOGIN_FAILED)
      EventBus.$emit('errorMessage', 'Error de comunicación con el servidor.')
    })
  },
  auth ({commit}, event) {
    commit(LOGIN)
    var url = 'users/auth/' + event.name.toLowerCase() + '/'
    EventBus.$emit('waitMessage')

    var chunk = JSON.stringify(event.data)
    return Vue.http.post(url, { data: chunk })
    .then(function (response) {
      var data = response.body
      if (data.status === 'ok') {
        data.user.birthdate = new Date(data.user.birthdate)
        localStorage.setItem('token', data.token)
        localStorage.setItem('user', JSON.stringify(data.user))
        commit(USER, data.user)
        commit(LOGIN_SUCCESS)
      } else {
        console.error('Error with comunication backend ->', data.message)
        commit(LOGIN_FAILED)
      }
    }, function (response) {
      console.error('Error with comunication backend ->', response)
      commit(LOGIN_FAILED)
    })
  },
  logout ({commit}) {
    commit(LOGOUT)
    return new Promise(resolve => {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      commit(USER, null)
      resolve()
    })
  },
  update ({commit}, user) {
    localStorage.setItem('user', JSON.stringify(user))
    commit(USER, user)
  }
}

const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  status: state => {
    return state.pending
  },
  user: state => {
    return state.user
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js